import { BrandGradientDefs, type IllustrationProps, Sparkle } from "./common";

export function EmptyData({ size = 120, ...props }: IllustrationProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      fill="none"
      aria-hidden
      {...props}
    >
      <BrandGradientDefs id="ed" />
      {/* Box body */}
      <path
        d="M 50 80 L 100 60 L 150 80 L 150 140 L 100 160 L 50 140 Z"
        fill="url(#ed-fill)"
        stroke="url(#ed-stroke)"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M 50 80 L 100 100 L 150 80" stroke="url(#ed-stroke)" strokeWidth="2" fill="none" />
      <path d="M 100 100 L 100 160" stroke="url(#ed-stroke)" strokeWidth="2" fill="none" opacity="0.6" />
      {/* Top tape */}
      <rect x="92" y="56" width="16" height="6" rx="2" fill="url(#ed-stroke)" opacity="0.85" />

      <Sparkle cx={170} cy={56} size={8} />
      <Sparkle cx={36} cy={170} size={6} opacity={0.5} />
    </svg>
  );
}
